import Header from '../../Components/Header';
import TableWithPagination from '../../Components/TableWithPagination';
import { useNewsPage } from './useNewsPage';

const NewsPage = () => {
	const { news, allLibraries, handleChangeLibrarySelected } = useNewsPage();
	const columns = [
		{ header: 'ID', accessor: 'id' },
		{ header: 'Title', accessor: 'title' },
		{ header: 'Is Active', accessor: 'active' },
		{ header: 'Actions', accessor: 'actions' },
	];

	return (
		<>
			<Header />

			<div className='flex flex-col items-center'>
				<div className='content w-full max-w-[1280px] flex flex-col items-center'>
					<h1 className='text-3xl font-bold pt-8 pb-12'>News</h1>

					<div className='table-container w-full'>
						<TableWithPagination
							data={news}
							columns={columns}
							allLibraries={allLibraries}
							onLibraryChange={handleChangeLibrarySelected}
						/>
					</div>
				</div>
			</div>
		</>
	);
};

export default NewsPage;
